import { render, staticRenderFns } from "./SendFirstNightWatchingNotice.vue?vue&type=template&id=60befc08"
import script from "./SendFirstNightWatchingNotice.vue?vue&type=script&lang=js"
export * from "./SendFirstNightWatchingNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports